var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.901,
    height: 7.505,
    viewBox: "0 0 7.901 7.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.323,4.439a.791.791,0,1,1,1.1-.194A.8.8,0,0,1,4.323,4.439ZM8.53,9.716H5.738a1.182,1.182,0,0,1-1.169-1L3.79,4.976H3l.786,3.856a1.979,1.979,0,0,0,1.955,1.675H8.53Zm.091-1.58H6.694l-.407-1.62A3.057,3.057,0,0,0,8.321,7V6.157a2.407,2.407,0,0,1-1.853-.494l-.648-.5a.894.894,0,0,0-.3-.15.873.873,0,0,0-.391-.024H5.121a.9.9,0,0,0-.727,1.031l.533,2.339a1.188,1.188,0,0,0,1.165.964H8.8l1.509,1.185.593-.593L8.621,8.136Z",
    transform: "translate(-3 -3.001)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPax);
export default __webpack_public_path__ + "static/media/Pax.64b43d9ed5217bc7a0582491289ac22c.svg";
export { ForwardRef as ReactComponent };